import { Component, HostListener, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { retry, Subscription } from 'rxjs';
import { CustBusService } from 'src/app/services/customer-search-bussiness-logic.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from '../../../models/Constants';
import * as _ from 'lodash';
import { GenesysCloudService } from 'src/app/services/genesys-cloud.service';
import { CustomerAccountBusinessLogicService } from 'src/app/services/customer-account-business-logic.service';
import { MatSelect } from '@angular/material/select';
import { AbtTheInteractionCardComponent } from '../abt-the-interaction-card/abt-the-interaction-card.component';
import { CallCustomerAttributes } from 'src/app/models/customer.model';
import { TimerService } from '../../../services/timer.service';
import { InteractionHistoryService } from '../../../services/interaction-history.service';
import { CreateAlertComponent } from '../create-alert/create-alert.component';
import { MatDialog } from '@angular/material/dialog';
import { CustomerAlertsService } from '../../../services/customer-alerts.service';
import { ApiService } from 'src/app/services/api.service';
import { Tab } from '../../../models/tab.model';
import { TbaDomainSelectionComponent } from "../../../components/customerAccounts/tba-domain-selection/tba-domain-selection.component";
import { PersonInternalIdComponent } from '../person-internal-id/person-internal-id.component';
import { PrivacyPolicyModalComponent } from '../privacy-policy-modal/privacy-policy-modal.component';


declare var $: any;

// expired Alert  static changes
// Need to be removed once feature work done for the same 
export interface PeriodicElement {
  title: string;
  author: string;
  expiration: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { title: 'Bad mobile phone number', author: 'Michaelangelo A', expiration: 'Jan-01-2023' },
  { title: 'Death notification', author: 'Michaelangelo A', expiration: 'Jan-01-2023' },
  { title: 'Care Portal', author: 'Al Borland', expiration: 'Jan-01-2023' },
  { title: 'Care Portal', author: 'Al Borland', expiration: 'Jan-01-2023' },
  { title: 'Care Portal', author: 'John Doe', expiration: 'Jan-01-2023' },
  { title: 'Care Portal', author: 'John Doe', expiration: 'Jan-01-2023' },
  { title: 'Bad mobile phone number', author: 'John Doe', expiration: 'Jan-01-2023' },
  { title: 'Care Portal', author: 'John Doe', expiration: 'Jan-01-2023' },
  { title: 'Care Portal', author: 'Al Borland', expiration: 'Jan-01-2023' },
  { title: 'Care Portal', author: 'John Doe', expiration: 'Jan-01-2023' },
];


export interface InteractionHistory {
  Date: string;
  Channel: string;
  Topic: string;
  Agent: string;
  StartTime: string;
}

interface Clientvalue {
  value: string;
  viewValue: string;
}


@Component({
  selector: 'app-customer-account',
  templateUrl: './customer-account.component.html',
  styleUrls: ['./customer-account.component.scss'],
})


export class CustomerAccountComponent implements OnInit, OnDestroy {

  // expired Alert  static changes
  // Need to be removed once feature work done for the same 
  displayedColumns: string[] = ['title', 'author', 'expiration'];
  dataSource = ELEMENT_DATA;

  // Below code to be used and to be removed from multiple places once all the dropdowns are made common.
  @ViewChild(MatSelect) select!: MatSelect;
  isIHListView: boolean = false;
  timerVal: any = '';
  @HostListener('window:scroll', [])
  onScroll(): void {
    if (this.select?.panelOpen) {
      this.select.close();
    }
  }
  iconConfig: any;
  iconConfig2: any;
  iconConfig3: any;
  panelOpenState = false;
  authenticateClass: string = '';

   tooltipHTMLContent_dob = `
  <span>
    <b class="bold-text">DOB</b> Aug 26 1988
  </span>
   `;

   tooltipHTMLContent_status = `
  <span>
    <b class="bold-text">Status Date</b> Oct 6 1988
  </span>
  `

  currentRoute: any;
  inboundMsg: string = Constants.INBOUND_CALL_ACCESS_ERRORMSG;
  closeAccountMsg: string = Constants.Close_Customer_Account_MSG;
  closeAccountChatMsg: string = Constants.Close_Account_Chat_Msg;
  idleTimerMsg: string = Constants.idleTimerMsg;
  buttonType: string = '';
  msg: string = '';
  customerAccountData: any;
  lastStartTime: any;


  // Need to remove below dummy variables once feature story pick for displaying alert  
  showContent1: boolean = true;
  showContent2: boolean = true;
  showContent3: boolean = true;
  showContent4: boolean = true;

  toOpenIdlePop: boolean = false;
  enableInbound: boolean = false;
  myTimeoutId: ReturnType<typeof setTimeout> | any;

  //selectedIndex = 0; //{ path: 0, index: 0 };
  selectedMenu: any = 1001;
  userSubscription!: Subscription;
  domainName: string = '';
  navbarMenu = Constants.navMenu;
  domainErrMsg: any;

  customerAccForm: FormGroup = new FormGroup({});
  showCreateAlert: boolean = false;
  showExpiredAlert: boolean = false;
  showDeleteAlert: boolean = false;
  IHParams: any;  // for IH list
  isViewAllEnable: boolean = false; //  to show IH list page
  selectedRow: any; // using to show selection on IH list page
  sideNavState: string = Constants.navMenu.carePortalCustomer; subMenuId: string = ""; tempMenuId: string = "";
  noDataMsg = Constants.DATA_NOT_AVAIL_UI;
  fileName: string = 'customer-account.component.ts';

  @ViewChild(AbtTheInteractionCardComponent) abtTheCustCard;
  constructor(
    public router: Router,
    public rootScope: RootScopeService,
    private route: ActivatedRoute,
    public customerService: CustBusService,
    public genesysCloudService: GenesysCloudService,
    public cusAccService: CustomerAccountBusinessLogicService,
    public timerService: TimerService,
    public initHistService: InteractionHistoryService,
    public dialog: MatDialog,
    public custAlertsService: CustomerAlertsService,
    private apiService: ApiService,
  ) {
    this.iconConfig = {
      iconName: 'arrow-right',
      iconType: 'light',
      iconPlacement: 'right',
    };

    this.iconConfig2 = {
      iconName: 'circle-plus',
      iconType: 'solid',
      iconPlacement: 'right',
    };
     this.iconConfig3 = {
      iconName: 'circle-info',
      iconType: 'light',
    };
    this.commonOverviewSUB()
  }

  @HostListener('window:resize', []) resize() {
    this.showContent1 = true;
    this.showContent2 = true;
    this.showContent3 = true;
    this.showContent4 = true;
  }






  /* Below TBA array[] values is currently hard-coded, when Feature Team interact with backend
     and implement dynamic side navbar hard-coded values would be removed */
  Tbavalues = [
    {
      fieldKey: 'customer-type',
      fieldValue: 'ee',
      fieldValueDescription: 'Employee',
      sequence: '10.00',
    },
    {
      fieldKey: 'customer-type',
      fieldValue: 'cw',
      fieldValueDescription: 'Contingent Worker',
      sequence: '11.00',
    },
    {
      fieldKey: 'customer-type',
      fieldValue: 'rkp',
      fieldValueDescription: 'Record Keeping Person',
      sequence: '12.00',
    },
    {
      fieldKey: 'customer-type',
      fieldValue: 'bene',
      fieldValueDescription: 'Beneficiary',
      sequence: '13.00',
    },
    {
      fieldKey: 'customer-type',
      fieldValue: 'qdro',
      fieldValueDescription: 'QDRO',
      sequence: '14.00',
    },
    {
      fieldKey: 'customer-type',
      fieldValue: 'poi',
      fieldValueDescription: 'Parties of Interest',
      sequence: '15.00',
    },
  ];


  /* Below headlines array[] values is currently hard-coded, when Feature Team interact with backend
     and implement dynamic side navbar hard-coded values would be removed */
  alertSubType = [
    {
      fieldKey: 'type',
      fieldValue: 'ee',
      fieldValueDescription: 'Customer has some policy issue',
      sequence: '10.00',
    },
    {
      fieldKey: 'type',
      fieldValue: 'cw',
      fieldValueDescription: 'Customer has some policy issue',
      sequence: '11.00',
    },
    {
      fieldKey: 'type',
      fieldValue: 'rkp',
      fieldValueDescription: 'Customer has some policy issue',
      sequence: '12.00',
    },

  ];








  clientControl = new FormControl();
  form = new FormGroup({
    client: this.clientControl,
  });


  // dataSource = ELEMENT_DATA;
  // prevParticipantId: any;
  // prevOutboundConvId: any;
  // prevOutboundBody: any;
  loaderType = Constants.LOADER_TYPE.CARD;

  showJsonViewer = false;
  jsonData: any = {
    key1: 'value1',
    key2: 'value2',
    key3: 'value3'
  };

  toggleJsonViewer() {
    this.showJsonViewer = true;
  }

  ngOnInit(): void {
    
      this.handleCustomerTypeApiFailure();
    this.timerVal = this.rootScope.activeCustTab.lastTimerValue;
    let that = this;
    setInterval(() => {
      that.timerVal = this.getTimerValForChat();
    }, 1000)

    this.initHistService.setWrapUpDefaultValue();

    const activeCustTab = this.rootScope.activeCustTab;
    const securityLevel = activeCustTab?.CS_SECURITY_LEVEL;
    const employeeId = activeCustTab?.employeeId;
    const last4DigitsOfSSN = activeCustTab?.last4DigitsOfSSN;
    const maskedOrShownEmployeeId = this.maskOrShowEmployeeId(employeeId, securityLevel);
    const maskOrNationalId = this.maskOrNationalId(last4DigitsOfSSN, securityLevel);
    const preferrdName = activeCustTab?.preferredName;
    const sectorName = activeCustTab?.sectorName;



    // code for side nav
    /* istanbul ignore next */
    this.userSubscription = this.route.params.subscribe((params: any) => {
      this.cusAccService.defaultServiceOnLoad();
      this.cusAccService.getAutoLaunchConfigurationData(this.rootScope.activeCustTab);

      // sessionStorage.setItem('activeTabId', params.id);
      const indicativeData = this.rootScope.activeCustTab?.authenticationIndicativeData?.indicativeData;
      if (indicativeData && indicativeData.length > 0 && this.cusAccService.indicativeDataForm) {
        this.cusAccService.indicativeDataForm.patchValue(this.rootScope.activeCustTab.authenticationIndicativeData.indicativeDataFormData);
      }
      this.custAlertsService.updateCustTabDataForExpiredAlerts();
      this.getExceptionAndSubException();
      this.isIHListView = false;
      let domainDt = this.rootScope.activeCustTab.domainIndex;

      this.cusAccService.activeTabDt =
        this.cusAccService.customerAccountDt.find(
          (x) => x?.id == this.rootScope.activeCustTab.customerSessionId
        );
      if (this.rootScope.authConfigUserDataMap[this.rootScope.activeCustTab.customerSessionId]) {
        this.rootScope.accountSAuthConfig = this.rootScope.authConfigUserDataMap[this.rootScope.activeCustTab.customerSessionId];
      } else if (this.rootScope.AaaSConfigUserDataMap[this.rootScope.activeCustTab.customerSessionId]) {
        this.rootScope.accountAaaSConfig = this.rootScope.AaaSConfigUserDataMap[this.rootScope.activeCustTab.customerSessionId];
      }
      if (!this.cusAccService.activeTabDt && this.rootScope.activeCustTab.restoreTab) {
        this.cusAccService.openNewCustAcc(this.rootScope.activeCustTab);
        this.domainName = Constants.domainCard.about;
        this.selectedMenu = this.navbarMenu.custOverview;
      }
      //console.log(" this.cusAccService.activeTabDt", this.cusAccService.activeTabDt)
      else if (
        domainDt?.domainId &&
        domainDt?.domainName &&
        this.cusAccService.activeTabDt?.id
      ) {

        if (domainDt?.domainId == this.navbarMenu.interactionHistoty) {
          this.goToListViewIHPage(null);
          this.isIHListView = true;
        }

        this.cusAccService.domainData =
          this.cusAccService.activeTabDt[domainDt.domainName];

        // console.log(
        //   'this.cusAccService.domainData ',
        //   this.cusAccService.domainData
        // );

        this.selectedMenu = domainDt?.domainId;
        this.cusAccService.selectedIndex =
          this.rootScope.activeCustTab.subDomainIndex;
        this.domainName = this.cusAccService.activeTabDt.domainName;
        this.subMenuId = Constants.navMenu.customerInfo;
        // this.sideNavState = domainDt?.domainId;
      } else {
        if (domainDt?.domainId == Constants.navMenu.authentication) {
          this.domainName = '';
          this.selectedMenu = this.navbarMenu.authentication;
        } else if (domainDt?.domainId == Constants.navMenu.approvedException) {
          this.domainName = '';
          this.selectedMenu = this.navbarMenu.approvedException;
        } else if (domainDt?.domainId == Constants.navMenu.wrap_up) {
          this.domainName = '';
          this.selectedMenu = this.navbarMenu.wrap_up;
        } else {
          this.domainName = Constants.domainCard.about;
          this.selectedMenu = this.navbarMenu.custOverview;
        }
        this.cusAccService.domainData = null;
        this.subMenuId = '';
        // this.cusAccService.selectedIndex =
        //   this.rootScope.activeCustTab.subDomainIndex;
        //  this.sideNavState = domainDt?.domainId;
        // this.cusAccService.activeTabDt['aboutTheCustomer'];
      }
      // added for Prod web Message issue CCR3-11668
      //istanbul ignore next
      if(this.rootScope.activeCustTab?.activeChat){
        this.rootScope.triggerLog("ACTIVE_CUSTOMER_TAB_CLIENT_ID: " + JSON.stringify(this.rootScope.activeCustTab.clientId), this.fileName)
      }
      this.checkDomainData();
      if (this.rootScope.accountModalPopup.has(this.rootScope.activeCustTab.customerSessionId)) {

        let activeDialog = this.rootScope.accountModalPopup.get(this.rootScope.activeCustTab.customerSessionId)

        this.rootScope[activeDialog[0]] = activeDialog[1];
        if (activeDialog[0] == 'openCreateAlertDialog') {
          this.rootScope.openInteractionFilter = false;
        }
        else {
          this.rootScope.openCreateAlertDialog = false;
        }
      }
      else {
        this.rootScope.openCreateAlertDialog = false;
        this.rootScope.openInteractionFilter = false;
      }
    });
    //this.identifyAuthenticateClass();
    //Added an optional "?" with activeCustTab to avoid 
    //Null Pointer Exception for CCR1-2683
    if (
      this.rootScope.activeCustTab?.activeCall &&
      this.rootScope.callType == Constants.INBOUND_CALL_TYPE
    ) {
      this.enableInbound = true;
    }

    if (this.rootScope.agenIneractionData.isAgentRowClicked
      && this.rootScope.agenIneractionData?.selectedRow?.udpId == this.rootScope.activeCustTab?.id
      && this.rootScope.activeCustTab.conversationId == "NA") {

      let data = {
        row: this.rootScope.agenIneractionData?.selectedRow,
        buttonName: 'Customer Account'

      }
      this.goToListViewIHPage(data);
      this.isIHListView = true;

    }
    this.rootScope.scrollToTop();
    // console.log('this', this.rootScope.isCallBackCall);
    console.log('Customer Account Object - Data = ', this.rootScope.activeCustTab);
  }


  /**
 * Below method handle the scenario wherein
 * customer type API is failing in app load .Thus rehitting
 * again on launch of customer account.
 */

  handleCustomerTypeApiFailure() {
    if (this.rootScope.customerTypeAPIFailure) {
      this.rootScope.customerTypeAPIFailure = false;
      this.apiService.getCustomerTypesAPI();
    }
  }



  openDomainSelector(menu) {
    this.dialog.open(TbaDomainSelectionComponent, {
      data: menu,
      panelClass: 'domain-selector',
      backdropClass: 'custom-overlay',
      disableClose: true,
      id: 'domainSelector'
    });

  }

  /** 
  * User Story -CCR3-12927
  * openPrivacyPolicy() -- opening privacy policy modal popup for getting user consent.
  * @author :Amarjeet Kumar
  */
    openPrivacyPolicy(isAuthCustChange?) {
    const dialogRef = this.dialog.open(PrivacyPolicyModalComponent, {
      data: isAuthCustChange,
      panelClass: 'Privacy-policy',
      backdropClass: 'custom-overlay',
      disableClose: true,
      id: 'privacypolicy'
    });

      dialogRef?.componentInstance?.goToAuthenticatePageEmitter?.subscribe(() => {
        this.selectedMenu = this.navbarMenu.authentication;
        this.rootScope.activeCustTab.domainIndex = {
          domainId: this.navbarMenu.authentication,
          domainName: Constants.COMMON,
        }
      });

      dialogRef?.componentInstance?.goToPrivacyPolicyEmitter?.subscribe(() => {
        this.selectedMenu = this.navbarMenu.privacyPolicy;
      });
  }

  /** 
  * checkData -- checking for cached data.
  * @author :Amarjeet Kumar
  */
  checkDomainData() {
    if (!this.rootScope.wrapupTopicDataMap[this.rootScope.activeCustTab.clientId])
      this.getDomainList()
  }

  /** 
   * getDomainList -- calling API to get getDomainList.
   * @author :Amarjeet Kumar
   */
  getDomainList() {
    this.apiService.getDomainList().subscribe({
      next: (data: any) => {
        this.rootScope.wrapupTopicDataMap[this.rootScope.activeCustTab.clientId] = data.data;
      },
      error: (error) => {
        console.log(error)
      },
    })
  }


  openCloseChatPopup() {
    this.rootScope.openCustomDialog(
      Constants.Close_Account_Chat_Msg,
      'NA',
      Constants.CANCEL_BUTTON_TYPE,
      Constants.CUSTOMER_ACNT,
      Constants.CLOSE_CHAT_POPUP,
      Constants.CLOSE_ADD_ACNT_BUTTON,
      'close-chat-modal'
    );
  }


  expiredAlert() {
    this.showExpiredAlert = true;
  }

  deleteAlert() {
    this.showDeleteAlert = true;
  }

  closeDeleteAlert() {
    this.showDeleteAlert = false;
  }

  closeAlertpopup() {
    this.showCreateAlert = false;
    this.showExpiredAlert = false;

  }

  customerAccountTabIdle() {
    if (this.openIdlePop()) {
      this.rootScope.openCustomDialog(
        Constants.idleTimerMsg,
        'NA',
        '',
        Constants.CUSTOMER_ACNT,
        Constants.IDLE_POP_UP,
        Constants.GOT_IT_BUTTON_TYPE,
        'idle-modal'
      );
    }
  }

  buttonClick(data) {
    let type = data['type'];
    let buttonType = data['buttonType'];
    if (type == Constants.IDLE_POP_UP) {
      this.customerService.idleTimeReset();
    } else if (type == Constants.OUTBOUND_POPUP) {
      // this.cancelTriggerOutboundCall();
    } else if (
      type == Constants.CLOSE_ADD_ACNT_BUTTON &&
      buttonType == Constants.CLOSE_ADD_ACNT_BUTTON
    ) {
      this.customerService.closeAddAccount();
    }
  }


  openPersonInternalId() {
    this.dialog.open(PersonInternalIdComponent, {
      panelClass: 'person-internal-id',
      backdropClass: 'custom-overlay',
      disableClose: true,
      id: 'internal-id'
    });
  }   



  /**
    * Method to call IH  List view page with brief view IH selected row data
    * @param row : brief view selected row data
    * @author :Amarjeet
    */
  goToListViewIHPage(row) {
    // console.log("clicled" + row)
    this.rootScope.clonedActiveCustTab = new Tab();
    this.rootScope.clonedActiveCustTab = _.cloneDeep(this.rootScope.activeCustTab);
    // this.selectedRow = row;
    this.selectedMenu = this.navbarMenu.interactionHistoty;
    this.isIHListView = true;
    this.rootScope.activeCustTab.domainIndex = {
      domainId: this.navbarMenu.interactionHistoty,
      domainName: Constants.COMMON,
    };
    //this.rootScope.agenIneractionData.isAgentRowClicked=false;
  }
  // this.sideNavState = Constants.navMenu.carePortalCustomer;

  goToAuthenticatePage(evnt) {
    // console.log("called auth")
    if (this.rootScope.activeCustTab.privacyPolicyStatus == 'true' && this.rootScope.isLiveCall && this.rootScope.activeCustTab.CS_SECURITY_LEVEL != Constants.securityLevels.SL4 && (this.rootScope.activeCustTab.customerType == Constants.customerType.ACH || this.rootScope.activeCustTab.customerType == Constants.customerType.LGF)) {
      this.openPrivacyPolicy();
      return;
    }
    this.selectedMenu = this.navbarMenu.authentication;
    this.rootScope.activeCustTab.domainIndex = {
      domainId: this.navbarMenu.authentication,
      domainName: Constants.COMMON,
    }
  }


  /**Below method redirect to the Approved Exception page
   * @author Sultan CCR3-2484
   *  */
  goToApprovedExceptionPage(event) {
    this.selectedMenu = this.navbarMenu.approvedException;
    this.rootScope.activeCustTab.domainIndex = {
      domainId: this.navbarMenu.approvedException,
      domainName: Constants.COMMON,
    }

  }







  gotIt() {
    this.rootScope.showInboundValidateMsg = false;
  }

  /* Below goToTbaCustomerAccount() method access the TBA Customer Account Screen
  from the Care Portal*/
  // goToTbaCustomerAccount() {
  //   let isConnected = localStorage.getItem('TBAGUIStatusConnected');
  //   if (!isConnected) {
  //     alert(
  //       'Please do TBA Registration from Care Portal, for Access TBA Customer Account.'
  //     );
  //   } else {
  //     this.customerService.tbaCustomerAccount().subscribe({
  //       next: (data: any) => {
  //         if (data?.httpStatusCode == 200) {
  //           console.log('goToTbaCustomerAccount', data);
  //         }
  //       },
  //       error: (error) => {
  //         console.log('Error in goToTbaCustomerAccount', error);
  //         this.rootScope.enableAlerts(
  //           Constants.ERROR,
  //           Constants.API_FAILURE_MSG
  //         );
  //       },
  //     });
  //   }
  // }

  idleTimeReset() {
    this.rootScope.activeCustTab.idle = false;
    // let timer = this.rootScope.getValueFromSessiondb('customerTabs', 2)
    // this.rootScope.CCTConfigs = timer == 2 ? this.rootScope.CCTConfigs : timer.idleTime;
    this.customerService.updateIdle(
      this.rootScope.activeCustTab,
      this.rootScope.CCTConfigs.TIME_THRESHOLD_SUBSEQUENT
    );
  }

  openIdlePop() {
    let status = (this.rootScope.activeCustTab?.idle && !this.rootScope.checkCallOrChat());

    if (status && this.rootScope.dropDown?.panelOpen) this.rootScope.dropDown.close();

    return status;
  }

  ShowPopup() { }



  onAnchorClick(path) {
    let x = document.querySelector('#' + path);
    if (x) {
      x.scrollIntoView();
    }
  }

  cancelTriggerOutboundCall() {
    this.abtTheCustCard?.cancelTriggerOutboundCall()
  }

  /**
   * 
   * @param roleType 
   * Below method returen abbrevated form of roleType for diaplying in left Nav
   * @returns 
   * @author :Pooja
   */

  getAbbrevatedRoleValue(roleType) {
    if (roleType) {
      if (Constants.AbbrevatedRoleMap[roleType])
        return Constants.AbbrevatedRoleMap[roleType];
      else if (roleType.startsWith(Constants.QDRO))
        return Constants.QDRO;
      else if (roleType.startsWith(Constants.BENE))
        return Constants.BENE;
      else return roleType;
    }
  }


  /**
   * Comments added in code itself
   * @author : Amarjeet
   */
  // sideNavState: boolean = false;
  /* istanbul ignore next */
  activateLeftMenu(id, i, menu?) {
    this.showJsonViewer = false;
    this.rootScope.isErrorToHide = true;
    this.rootScope.isWarningToHide = true;
    this.isIHListView = false;

    let componentName;
    this.rootScope.activeCustTab.roleObj = this.cusAccService.activeTabDt?.roleTypeList?.find(x => x.roleName == this.rootScope.activeCustTab.defaultRole);
      /* 
    @Author Jaya
    CCr6-1894 Handling Partial Overlays behavior for Left Nav. 
    */
    if (this.selectedMenu != id) {
      if (this.rootScope.openCreateAlertDialog) {
        this.rootScope.openCreateAlertDialog = false;
        this.apiService.getCustomerPanelId();
        this.rootScope.accountModalPopup.set(this.rootScope.activeCustTab.customerSessionId, ['openCreateAlertDialog', false]);
        this.rootScope.panelIdList.delete(this.rootScope.activeCustTab.customerSessionId);
      }
      else if (this.rootScope.openInteractionFilter) {
        this.rootScope.openInteractionFilter = false;
        this.rootScope.accountModalPopup.set(this.rootScope.activeCustTab.customerSessionId, ['openInteractionFilter', false]);
      }
      // if (this.rootScope.activeCustTab.outboundCallInitiate) {
      //   this.cancelTriggerOutboundCall();
      // }
      else if (this.rootScope.activeCustTab.idle) {
        this.idleTimeReset();
      }
      else if (this.rootScope.customDialogData.displayCustomDialogCA)
        this.rootScope.customDialogData.displayCustomDialogCA = false;
    }

    if (menu?.actionCode == 'LINK_ACTION') {
      componentName = this.selectedMenu;
      const linkType = menu?.link?.linkType;
      const linkId = menu?.link?.linkId;

      const isStandAlone = this.rootScope.activeCustTab.tabData.tabData?.idMapping
        .filter(x => x?.platformType?.includes('TBA'))?.length === 1;


      if (linkType === Constants.LINK_TYPE.TBA && linkId != 'TBA-SYSTEM' && !isStandAlone) {

        /******* Below piece of code added to handle if idMapping have multiple entry of 
           same domain Names, It should be considered as single entry CCR1-10675 **********/
           
        const filteredMappings = this.rootScope.activeCustTab.tabData.tabData.idMapping.
          filter(mapping => mapping.platformType.includes('TBA'));
        
        let domainList = _.map(filteredMappings, item => item.domains);
        domainList = Array.from(new Set(domainList));  /**Remove duplicate values */
        if (domainList &&  domainList.length > 1)
          this.openDomainSelector(menu);
        else {
          if (domainList && domainList.length > 0) {
            menu.domain = domainList[0];
          }
          this.launchLPOrNavigate(menu);
        }
      } else {
        this.launchLPOrNavigate(menu);
      }
    }
    else {
      if (id == Constants.navMenu.authentication && this.rootScope.isLiveCall && this.rootScope.activeCustTab.privacyPolicyStatus == 'true' &&  this.rootScope.activeCustTab.CS_SECURITY_LEVEL!=Constants.securityLevels.SL4 &&  (this.rootScope.activeCustTab.customerType==Constants.customerType.ACH || this.rootScope.activeCustTab.customerType==Constants.customerType.LGF)) {
        this.openPrivacyPolicy();   
         return; 
      }
      else {
        componentName = menu.id;
        this.selectedMenu = id; this.subMenuId = '';
      }
      
    }
  

    if (componentName == this.navbarMenu.custOverview) {
      this.domainName = Constants.domainCard.about;
      this.rootScope.activeCustTab.domainIndex = {
        domainId: this.navbarMenu.custOverview,
        domainName: Constants.domainCard.about,
      };
    } else if (componentName == this.navbarMenu.authentication) {
      this.cusAccService.domainData = null;
      this.goToAuthenticatePage(null);
    } else if (componentName == this.navbarMenu.approvedException) {
      this.cusAccService.domainData = null;
      this.goToApprovedExceptionPage(null);
    } else if (componentName == this.navbarMenu.interactionHistoty) {
      this.cusAccService.domainData = null;
      this.goToListViewIHPage(null);
    } else if (componentName == this.navbarMenu.wrap_up) {
      this.cusAccService.domainData = null;
       this.rootScope.activeCustTab.domainIndex = {
        domainId: this.navbarMenu.wrap_up,
        domainName: Constants.navMenu.wrap_up,
      };
    } else if (componentName == this.navbarMenu.onDemandEmail) {
      this.cusAccService.domainData = null;
    } else if (componentName == this.navbarMenu.viewJson) {
      this.rootScope.activeCustTab.domainIndex = {
        domainId: this.navbarMenu.viewJson,
        domainName: Constants.domainCard.common,
      };
      this.cusAccService.domainData = null;
    }  
    
    else {

      if (menu?.actionCode != 'LINK_ACTION' || this.rootScope.activeCustTab.selectedLeftNavMenu.parentMenuId == Constants.navMenu.customerInfo) {

        if (menu?.actionCode == 'LINK_ACTION') {
          menu = this.rootScope.activeCustTab.selectedLeftNavMenu;
        }

        this.subMenuId = Constants.navMenu.customerInfo;
        // this.selectedIndex = this.cusAccService.domainData?.topics[0].id;
        this.domainName = menu?.heading;
        this.cusAccService.activeTabDt.domainName = menu?.heading;
        let tabIndex = this.cusAccService.customerAccountDt.findIndex(
          (x) => x?.id == this.rootScope.activeCustTab.customerSessionId
        );
        if (this.cusAccService.activeTabDt[menu.domain]) {
          if (this.cusAccService.domainData?.domain) {
            this.cusAccService.activeTabDt[
              this.cusAccService.domainData.domain
            ].index = this.cusAccService.domainData.index;
          }
          this.cusAccService.domainData =
            this.cusAccService.activeTabDt[menu.domain];

          this.cusAccService.selectedIndex = this.cusAccService.domainData.index;
        } else
          this.cusAccService.getDomainDetails(
            this.rootScope.activeCustTab,
            menu,
            tabIndex
          );
      }
      this.rootScope.activeCustTab.selectedLeftNavMenu = menu;
      this.rootScope.activeCustTab.domainIndex = {
        domainId: id,
        domainName: menu.domain,
      };
      setTimeout(() => {
        this.rootScope.scrollToTop();
      }, 70);
    }
  }

  /**
   * Below method handles LP launch or normal navigation from left nav.
   * Story: CCR3-16020
   * @author : Vamsikrishna pamidala
   */
  launchLPOrNavigate(menu) {
    if (menu?.link?.linkPropertiesValues && this.rootScope.validate_LP_Menu(menu)) {
      this.rootScope.updateLinkTrackingMap(this.rootScope.activeCustTab.id, menu?.heading, menu?.link?.linkType);
      this.cusAccService.autoLaunchConfigService.openLeaveproLink(this.rootScope.activeCustTab, menu.link.linkPropertiesValues, Constants.LP_PLATFORM_TYPE);
    } else {
      this.rootScope.selectedLeftNavBarLink(menu, true);
    }
  }

  /**
   * Comments added in code itself
   * @author : vamsi krishna
   */
  clientSecurityLevel(index, temp?) {
    /**Below piece of code is for not displaying clientName values coming from backend as now value will be displayed from frontend */
    if (index == 0) {
      return true;
    }
    return false;
  }

  /**Below method returns clientName .Used in left nav client Info
   * @author : Pooja Gupta
   */
  getClientName() {
    return this.customerService.getClientName(
      this.rootScope.activeCustTab ? this.rootScope.activeCustTab.clientId : '00095'
    );
  }


  showDivider() {
    if (this.cusAccService?.activeTabDt?.clientInfoErrMSg && this.cusAccService?.activeTabDt?.clientInfoErrMSg != 'NA' && this.cusAccService?.activeTabDt?.clientInfoErrMSg != this.noDataMsg
      && this.cusAccService?.activeTabDt?.navBarErrMsg && this.cusAccService?.activeTabDt?.navBarErrMsg != 'NA' && this.cusAccService?.activeTabDt?.navBarErrMsg != this.noDataMsg) {
      return false;
    }
    else {
      return true;
    }
  }

  /**Below method update the value of customer type of customer account in ALIS Customer Attribute
   *  if the user on live call and it should not be transferred/conference call. */
  onCustomerTypeChange(event: any) {
    if (this.rootScope.activeCustTab?.domainIndex?.domainId == Constants.navMenu.authentication && this.rootScope.activeCustTab.privacyPolicyStatus == 'true' && this.rootScope.activeCustTab.CS_SECURITY_LEVEL != Constants.securityLevels.SL4 && (event?.value == Constants.customerType.ACH || event?.value == Constants.customerType.LGF)) {
      this.openPrivacyPolicy(true);
    }
    else {
    this.rootScope.callertTypeValue.oldTypeValue = JSON.parse(JSON.stringify(this.rootScope.activeCustTab.customerType));
    this.rootScope.callertTypeValue.newTypeValue = event.value;

    if (this.cusAccService.customerTypeValidation()) {
      let authAcess = this.cusAccService.validateAuthAccess(this.rootScope.activeCustTab);

      if (authAcess && this.rootScope.activeCustTab.CS_SECURITY_LEVEL != Constants.securityLevels.SL4) {
        this.updateGenesysAttributes(event, true);
      }
      else if (this.rootScope.activeCustTab.genesysAttributes?.CS_AUTH_CD
        && !authAcess && this.rootScope.activeCustTab.CS_SECURITY_LEVEL == Constants.securityLevels.SL4) {
        this.rootScope.customerTypeForm.get('customerType')?.setValue(this.rootScope.callertTypeValue.oldTypeValue);
        this.rootScope.callerTypeAlert = true;
      }
      else {
        this.updateGenesysAttributes(event, false);
      }

    } else {
      this.rootScope.activeCustTab.customerType = event.value;
      this.reflectsOnCallerChange();
    }
   }
  }


  updateGenesysAttributes(event, authAcess?) {
    this.rootScope.activeCustTab.customerType = event.value;
    this.updateCustTypeInLiveInteraction(authAcess ? this.cusAccService.getAttributeModel() : null);
    this.reflectsOnCallerChange(authAcess);
  }

  closeCTPopUp(event?) {
    if (event) {
      this.rootScope.activeCustTab.customerType = this.rootScope.callertTypeValue.newTypeValue;
      this.rootScope.customerTypeForm.get('customerType')?.setValue(this.rootScope.callertTypeValue.newTypeValue);
      this.rootScope.activeCustTab.pinEntryApp.success = null;
      this.rootScope.activeCustTab.pinEntryApp.pinValidMsg = false;
      this.rootScope.activeCustTab.pinEntryApp.indValidMsg = false;
      this.rootScope.activeCustTab.pinEntryApp.securityDowngraded = true;
      this.updateCustTypeInLiveInteraction(this.cusAccService.getAttributeModel());
    } else {
      this.rootScope.activeCustTab.customerType = this.rootScope.callertTypeValue.oldTypeValue;
      if (this.rootScope.activeCustTab.pinEntryApp.success == 'true') {
        this.rootScope.activeCustTab.pinEntryApp.pinValidMsg = true;
        this.rootScope.activeCustTab.authenticationPinEntryData.isCustomerChanged = true;
      }
      else {
        this.rootScope.activeCustTab.pinEntryApp.indValidMsg = true;
        this.rootScope.activeCustTab.authenticationIndicativeData.isCustomerChanged = true;
      }

    }
    this.reflectsOnCallerChange(event ? true : false);
    this.rootScope.callerTypeAlert = false;
    this.rootScope.activeCustTab.pinEntryApp.pinValidMsg = false;
    this.rootScope.activeCustTab.pinEntryApp.step1Active = true;
    this.rootScope.activeCustTab.pinEntryApp.step1Complete = false;
    this.rootScope.activeCustTab.pinEntryApp.step2Active = false;
    this.rootScope.activeCustTab.pinEntryApp.step3Active = false;
    this.rootScope.activeCustTab.pinEntryApp.step3Complete = false;
  }

  reflectsOnCallerChange(acess?) {
    this.cusAccService.getExceptionandSubException();
    let updtCustPayload = {
      customerSessionId: this.rootScope.activeCustTab.customerSessionId,
      cusTab: { customerType: this.rootScope.activeCustTab.customerType },
    };
    let emptyAuthEgainContent = {
      name: '',
      content: ''
    }
    if (!this.rootScope.activeCustTab?.authenticationIndicativeData?.isCustomerChanged || acess || !this.rootScope.activeCustTab.authenticationPinEntryData.isCustomerChanged) {
      this.rootScope.activeCustTab.authenticationEgainContent.authenticationHtml = emptyAuthEgainContent;
      this.rootScope.activeCustTab.authenticationEgainContent.authenticationType = '';
      if (!this.rootScope.activeCustTab?.authenticationIndicativeData?.isCustomerChanged) {
        this.rootScope.activeCustTab.authenticationIndicativeData.isCustomerChanged = false;
      }
      if (!this.rootScope.activeCustTab.authenticationPinEntryData.isCustomerChanged) {
        this.rootScope.activeCustTab.authenticationPinEntryData.isCustomerChanged = false
      }
    }
    this.customerService.getAuthenticationMethods(this.rootScope.activeCustTab.clientId, this.rootScope.activeCustTab.customerType);
    if (acess) {
      if (this.rootScope.activeCustTab.pinEntryApp.success == 'true') {
        this.rootScope.activeCustTab.pinEntryApp.pinValidMsg = true;
      } else {
        this.rootScope.activeCustTab.pinEntryApp.indValidMsg = true;
      }
      updtCustPayload.cusTab['genesysAttributes'] = this.rootScope.activeCustTab.genesysAttributes;
      updtCustPayload.cusTab['CS_SECURITY_LEVEL'] = this.rootScope.activeCustTab.CS_SECURITY_LEVEL;
      updtCustPayload.cusTab['iconClass'] = this.rootScope.activeCustTab.iconClass;
      updtCustPayload.cusTab['authenticateStatus'] = this.rootScope.activeCustTab.authenticateStatus;
      this.customerService.updateTabSL(updtCustPayload);
      setTimeout(() => {
        this.goToCustomerOveriew(event);
      }, 100);
    }
    else this.customerService.updateCustomerInElasticCache(updtCustPayload);
    // if (
    //   this.rootScope.activeCustTab.activeCall &&
    //   !this.rootScope.activeCustTab.additionalAccount
    // ) {

    //   this.updateCustTypeInLiveInteraction();
    // }
  }

  /** Below method call Genesys Cloud Service updateParticipantAttributes method and update the body in ALIS Participant
   *  Attributes if the user on live chat or call.*/
  updateCustomerTypeParticipantAttributes(conversationId, participantId, body) {
    this.genesysCloudService
      .updateParticipantAttributes(conversationId, participantId, body)
      .subscribe({
        next: (res) => {

          // console.log(JSON.stringify(res));
          this.genesysCloudService.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.logEvent.SUCCESS, res?.["attributes"]);
        },
        error: (err) => {
         if (!this.rootScope.simulationData.isSimulationToggleOn) {
          this.rootScope.isGENSYSErrorToHide = false;
          this.rootScope.errorMsg = Constants.GENSYS_CONS[401] + Constants.AlertMsg.genesysError;
          this.rootScope.indicatorClass = 'red';
          console.log(JSON.stringify(err));
          this.genesysCloudService.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.logEvent.FAILURE, err);
          }
        },
      });
  }




  /** Below method update the value of customer type of customer account in ALIS Customer Attributes
   *  if the user on live chat.*/
  updateCustTypeInLiveInteraction(data?) {
    let conversationId = this.rootScope.activeCustTab?.conversationId, participantId = this.rootScope.activeCustTab?.customerParticipantId;
    if (this.rootScope.activeCustTab?.activeCall) {
      conversationId = this.rootScope.genesysCallObj?.eventBody?.id;
      let liveCustomer = this.rootScope.genesysCallObj?.eventBody?.participants.find(
        (x) =>
          x?.['purpose'] == 'customer' &&
          x?.['state'] == 'connected'
      );
      participantId = liveCustomer?.id || this.rootScope.activeCustTab?.customerParticipantId;//CCR5-774

    }

    let body: CallCustomerAttributes = {
      attributes: data ? data : {
        CUSTOMER_TYPE: this.rootScope.activeCustTab.customerType,
        CS_CALLER_TYPE: this.rootScope.activeCustTab.customerType, //added to transfer call from CSPro to Care Portal
      },
    };
    this.updateCustomerTypeParticipantAttributes(
      conversationId,
      participantId,
      body
    );
    //this.reflectsOnCallerChange();
  }


  getStartTime() {
    // console.log("method getSTartTimec called",this.rootScope.activeCustTab.lastStartTime)
    let time = this.timerService.connectedTime;
    // console.log("this.rootScope.activeCustTab.startTime",this.rootScope.activeCustTab.startTime)
    // console.log("this.rootScope.isConversationIdPresent()",this.rootScope.isConversationIdPresent())
    // console.log("time",this.timerService.connectedTime)

    if (!this.rootScope.activeCustTab.activeCall && !this.rootScope.activeCustTab.activeChat && this.rootScope.isConversationIdPresent()) {
      return this.rootScope.activeCustTab.lastStartTime;
    }
    else {
      if (this.rootScope.isConversationIdPresent()) {
        time = this.rootScope.activeCustTab.startTime
        // console.log("startTime",this.rootScope.activeCustTab.startTime)
      }
      this.rootScope.activeCustTab.lastStartTime = this.initHistService.getTime(time);
      return this.rootScope.activeCustTab.lastStartTime;
    }


  }
  /**
   * @author - Sultan Khan
 * Retrieves exception and sub-exception data based on the selected customer type and approved exceptions.
 * Updates the rootScope exceptions and sub-exceptions lists.
 */
  getExceptionAndSubException() {
    this.rootScope.customerTypeForm.patchValue({
      customerType: this.rootScope.activeCustTab.customerType
    });

    this.rootScope.approvedTypeExceptionForm.patchValue({
      type: this.rootScope.activeCustTab.approvedExceptionsTypes?.selectedException,
      subType: this.rootScope.activeCustTab.approvedExceptionsTypes?.selectedSubException
    });

    this.rootScope.exceptionsList = [];
    this.rootScope.subExceptionsList = [];

    const customerTypeFilterData = this.rootScope.activeCustTab.approvedExceptionsTypes
      .find(x => x?.exceptionsData?.customerType === this.rootScope.activeCustTab.customerType);

    if (customerTypeFilterData && customerTypeFilterData.exceptionsData) {
      this.rootScope.exceptionsList = customerTypeFilterData.exceptionsData?.exceptions;
      const exceptionFilterData = customerTypeFilterData.exceptionsData?.exceptions
        .find(x => x?.exception_description === this.rootScope.activeCustTab.approvedExceptionsTypes?.selectedException);
      if (exceptionFilterData) {
        this.rootScope.subExceptionsList = exceptionFilterData.exception_subtypes;
      }
    } else {
      this.cusAccService.getApprovedExceptionsListByClientId(this.rootScope.activeCustTab.customerType,false);
    }
  }

  enableTimerRowForChat() {

    if (this.rootScope.activeCustTab.channel != Constants.IH_CHAT) {
      return;
    }
    if (this.rootScope.activeCustTab.activeChat && !this.rootScope.activeCustTab.additionalAccount) {
      /**Display the timer Row when chat is connected for main account */
      return true;
    }
    else if (!this.rootScope.activeCustTab.activeChat && !this.rootScope.activeCustTab.additionalAccount && this.rootScope.isConversationIdPresent()) {
      /**Display the timer Row when chat is disconnected for main account i.e it will have conversationId attached to it */
      return true;
    }
    else
      return false;
  }

  /**
   * Timer row will be displayed only in main account not in 
   * additiona; account and only in live mode as per requirement of story CCR1-3816
   * @author :Pooja Gupta
   */

  enableTimerRow() {

    if (this.rootScope.activeCustTab.channel != Constants.IH_CALL) {
      return;
    }

    if (this.rootScope.activeCustTab.activeCall && !this.rootScope.activeCustTab.additionalAccount) {
      /**Display the timer Row when call is connected for main account */
      return true;
    }
    else if (!this.rootScope.activeCustTab.activeCall && !this.rootScope.activeCustTab.additionalAccount && this.rootScope.isConversationIdPresent()) {
      /**Display the timer Row when call is disconnected for main account i.e it will have conversationId attached to it */
      return true;
    }
    else
      return false;
  }

  getTimerValForChat() {
    if (this.rootScope.activeCustTab.activeChat) {
      let currentTime = new Date().toISOString();
      let value = this.initHistService.getDuration(this.timerService.timerMap[this.rootScope.activeCustTab.customerSessionId], currentTime);
      this.rootScope.activeCustTab.lastTimerValue = value;
      return value;
    }
    else {
      return this.rootScope.activeCustTab.lastTimerValue;
    }

  }

  /**
   * 
   * @returns 
   * @author :Pooja
   */
  getTimerVal() {

    if (this.rootScope.activeCustTab.activeCall) {
      let startTime = this.timerService.connectedTime;
      // console.log("startTime", startTime)
      let currentTime = new Date().toISOString();
      let value = this.initHistService.getDuration(startTime, currentTime)
      this.rootScope.activeCustTab.lastTimerValue = value;
      return value;
    }
    else {
      return this.rootScope.activeCustTab.lastTimerValue;
    }


    // let cloneObj = _.cloneDeep(this.timerService?.timerMap)
    // if (cloneObj[this.rootScope.activeCustTab.customerSessionId] && cloneObj[this.rootScope.activeCustTab.customerSessionId]["timerValue"]) {
    //   return cloneObj[this.rootScope.activeCustTab.customerSessionId]["timerValue"];
    // }
    // else
    //   return '';

  }

  /**
   * Below method is for disabling wrap up link in researcha and additional account mode
   * and enabling in main account mode. story CCR1-4201
   * @param menu 
   * @returns 
   */

  enableLink(menu) {
    //console.log("submeu",menu)
    // return true;
    const activeTab = this.rootScope.activeCustTab;

    if (menu?.id == Constants.navMenu.wrap_up) {

      if (this.rootScope.activeCustTab.additionalAccount) {
        return false;
      }
      else if (activeTab?.isMultipleAccountTabOpened &&
        activeTab.multiAccountRecord[activeTab.multiAccountRecord?.length - 1]?.udpId != activeTab.id) {
        return false;
      }
      else if (this.rootScope.activeCustTab.activeCall || this.rootScope.isConversationIdPresent()) {
        return true;
      }
      else {
        return false;
      }
    }
    else if (menu?.id == Constants.navMenu.approvedException) {
      if (this.rootScope.activeCustTab.additionalAccount) {
        return false;
      }

    }
    else if (menu?.id == Constants.navMenu.authentication) {
      if (this.rootScope.activeCustTab.additionalAccount) {
        return false;
      }
    }
    else if (menu.id == Constants.navMenu.onDemandEmail) {
      /**Below Condition are added to disable On-Demand email link in Research mode and for Additional account */
      if (this.rootScope.isConversationIdPresent()) {
        if (this.rootScope.activeCustTab.additionalAccount) {
          return false;
        }
        return true;
      } else {
        return false;
      }
    }

    return menu?.linkEnable
  }
  /** 
 * createAlert -- calling CreateAlertComponent component for creating Alerts.
 * @author :Amarjeet Kumar
 */
  openCreateAlert() {
    this.rootScope.openCreateAlertDialog = true;
    this.rootScope.accountModalPopup.set(this.rootScope.activeCustTab.customerSessionId, ['openCreateAlertDialog', true]);
  }

  closeCreateAlert() {
    this.rootScope.openCreateAlertDialog = false;
    this.rootScope.accountModalPopup.set(this.rootScope.activeCustTab.customerSessionId, ['openCreateAlertDialog', false]);
  }

  // updateSecurityForAPEX() {
  //   this.domainName = Constants.domainCard.about;
  //   this.selectedMenu = this.navbarMenu.custOverview;
  // }


  /*
Method to redirect to Customer overiew Page
*/
  goToCustomerOveriew(event) {
    this.isIHListView = false;
    this.selectedMenu = this.navbarMenu.custOverview;
    this.rootScope.activeCustTab.domainIndex = {
      domainId: this.navbarMenu.custOverview,
      domainName: Constants.COMMON,
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  //Girish --CCR1-5174
  /**
    * Method to make Govt ID nad EE ID masked having Security Level
    * @author :Girish
    */

  getPrimaryLanguageOrPreferredLocale(): string {
    const primaryLanguage = this.rootScope.activeCustTab?.primaryLanguage;
    const preferredLocale = this.rootScope.activeCustTab?.preferredLocale;

    if (primaryLanguage) {
      return primaryLanguage;
    } else if (preferredLocale) {
      return preferredLocale;
    } else {
      return '';
    }
  }
  getPronouns(): string {
    return this.rootScope.activeCustTab?.pronouns ? this.rootScope.activeCustTab.pronouns : '';
  }

  getCustomerType(customerType: string): string {
    const customerTypes = this.rootScope.activeCustTab?.customerType;
    return customerType;
  }


  maskOrShowEmployeeId(employeeId: string | undefined, securityLevel: string): string {
    if (securityLevel === Constants.securityLevels.SL0 || securityLevel === Constants.securityLevels.SL4) {
      if (employeeId !== undefined && employeeId !== null && employeeId != 'NA') {
        return employeeId;
      } else {
        return '';
      }
    } else {
      const maskedId = employeeId ? '*'.repeat(Math.min(8, employeeId.length)) : '';
      return maskedId.padEnd(8, '*');
    }
  }

  maskOrNationalId(last4DigitsOfSSN: string | undefined, securityLevel: string): string {
    if (securityLevel === Constants.securityLevels.SL0 || securityLevel === Constants.securityLevels.SL4) {
      if (last4DigitsOfSSN !== undefined && last4DigitsOfSSN !== null && last4DigitsOfSSN != 'NA') {
        return last4DigitsOfSSN;
      } else {
        return '';
      }
    } else {
      const maskedId = last4DigitsOfSSN ? '*'.repeat(Math.min(8, last4DigitsOfSSN.length)) : '';
      return maskedId.padEnd(8, '*');
    }
  }

  /**
   * to handle all authentication method 
   * to show secuirty/auth status in customer overview page
   */
  commonOverviewSUB() {
    this.customerService.goToCustOverView.subscribe(res => {
      if (res) {
        this.goToCustomerOveriew(true);
      }
    })
  }

  /** 
 * refreshCustAccount() -- calling All customer Account view related API on refresh account click.
 * @author :Amarjeet Kumar
 */
  refreshCustAccount() {
    this.custAlertsService.refreshedClicked = true;
    this.initHistService.refreshBriefData = true;
    this.initHistService.refreshListData = true;
    this.cusAccService.openNewCustAcc(this.rootScope.activeCustTab);
    this.domainName = Constants.domainCard.about;
    this.selectedMenu = this.navbarMenu.custOverview;
    this.cusAccService.getClientInfoCardData(this.rootScope.activeCustTab.clientId, true);
    this.custAlertsService.refreshAlerts.next(true);
    this.initHistService.refreshIHData.next(true);
    if (this.rootScope?.activeCustTab?.selectedLeftNavMenu && this.rootScope?.activeCustTab?.selectedLeftNavMenu.domain) {
      this.cusAccService.refreshDomain()
    }
    this.cusAccService.getPersonRefreshData(this.rootScope.activeCustTab);
    this.goToCustomerOveriew(true);
  }

  accountFreezeStatus(): boolean {
    if (this.rootScope.activeCustTab.activeCall) {
      if (this.rootScope.activeCustTab.personStatus == Constants.SAuthStatus.AF) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }


  ngOnDestroy() {
    clearTimeout(this.rootScope.custAccInteractionLoaderTimeoutId);
    this.rootScope.showCustAccInteractionLoaderMsg = false;
    this.rootScope.custAccInteractionLoader = false;
  }

  

}
